import { Component, OnInit, Renderer2 } from "@angular/core";
import * as FileSaver from "file-saver";
import { CommonModule, DatePipe } from "@angular/common";
import { TableFilterEvent, TableModule } from "primeng/table";
import { CustomerAgingDetailReport } from "../../../../core/models/reports/customerAgingDetailReport";
import { ReportsService } from "../../../../core/services/reports.service";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { CustomerSettlementComponent } from "../customer-settlement/customer-settlement.component";

@Component({
  selector: "jni-customer-aging-detail-report",
  templateUrl: "./customer-aging-detail-report.component.html",
  styleUrls: ["./customer-aging-detail-report.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DateFilterComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
    CustomerSettlementComponent,
  ],
})
export class CustomerAgingDetailReportComponent implements OnInit {
  orderDisplayModal = false;
  clientDisplayModal = false;
  settlementDisplayModal = false;
  clientId = "";
  saleOrderId = "";
  clientSettlementId = 0;
  showDisputeColumn = false;

  customerAgingDetailReportLists: CustomerAgingDetailReport[] = [];
  filterCustomerAgingDetailReportLists: CustomerAgingDetailReport[] = [];
  filterDataCustomerAgingDetailReportLists: CustomerAgingDetailReport[] = [];
  invDateColumn = "invDate";
  dueDateColumn = "dueDate";

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private _dashboardService: DashboardService,
    private renderer: Renderer2,
    public datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const source = (window.opener as any)?.sourcePage;
    /* eslint-enable @typescript-eslint/no-explicit-any */
    this.showDisputeColumn = source === "dashboard";

    if (this.showDisputeColumn) {
      this.getCustomerAgingDisputeReport();
    } else {
      this.getCustomerAgingDetailReport();
    }
  }

  getCustomerAgingDetailReport() {
    this._loaderService.setLoaderState(true);
    this._reportsService.getCustomerAgingDetailReport().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.customerAgingDetailReportLists = res.data;
          this.filterDataCustomerAgingDetailReportLists =
            this.customerAgingDetailReportLists;
          this.filterCustomerAgingDetailReportLists =
            this.customerAgingDetailReportLists;
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  getCustomerAgingDisputeReport() {
    this._loaderService.setLoaderState(true);
    this._reportsService.getCustomerAgingDisputeReport().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.customerAgingDetailReportLists = res.data;
          this.filterDataCustomerAgingDetailReportLists =
            this.customerAgingDetailReportLists;
          this.filterCustomerAgingDetailReportLists =
            this.customerAgingDetailReportLists;
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  // onInvDateDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.customerAgingDetailReportLists.filter((x) =>
  //       x.invDate?.includes(event.target.value)
  //     );
  //     this.filterCustomerAgingDetailReportLists = filterList;
  //   } else {
  //     this.filterCustomerAgingDetailReportLists =
  //       this.customerAgingDetailReportLists;
  //   }
  // }

  // onDueDateDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.customerAgingDetailReportLists.filter((x) =>
  //       x.dueDate?.includes(event.target.value)
  //     );
  //     this.filterCustomerAgingDetailReportLists = filterList;
  //   } else {
  //     this.filterCustomerAgingDetailReportLists =
  //       this.customerAgingDetailReportLists;
  //   }
  // }

  getInvoiceReport(invoiceId: string) {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getInvoiceReport(invoiceId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  redirectToClient(client: string) {
    //const url = `/clients/active/client-details/${client}`;
    //this.route.navigate([url]);
    if (client) {
      this.clientId = client;
      this.clientDisplayModal = true;
    }
  }

  // redirectToVendor(vendor: string) {
  //   //const url = `/vendors/vendor-summary/${vendor}`;
  //   //this.route.navigate([url]);
  // }

  redirectToSaleorder(saleorder: string) {
    //const url = `/orders/order-summary/${saleorder}`;
    //this.route.navigate([url]);
    if (saleorder) {
      this.saleOrderId = saleorder;
      this.orderDisplayModal = true;
    }
  }

  redirectToCustomerSettle(refRecId: number) {
    //const url = `reports/customer-settlement/${refRecId}`;
    // this.route.navigate([url]);
    if (refRecId) {
      this.clientSettlementId = refRecId;
      this.settlementDisplayModal = true;
    }
  }
  exportExcelFile() {
    this.exportExcelForFilterData(
      this.filterDataCustomerAgingDetailReportLists
    );
  }

  exportExcelForFilterData(filterclientlist: CustomerAgingDetailReport[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Invoice"]: datum.invoice,
        ["Sale Order"]: datum.salesOrder,
        ["Project Name"]: datum.projectName,
        ["Client Account"]: datum.customerAccount,
        ["Client"]: datum.customer,
        ["Days Outstanding"]: datum.daysOutstanding,
        ["Bucket"]: datum.bucket,
        ["Inv Amt Usd"]: datum.invAmountUSD,
        ["Open Amt Usd"]: datum.openAmountUSD,
        ["Currency"]: datum.currency,
        ["Invoice Amt"]: datum.invoiceAmount,
        ["Payments"]: datum.payments,
        ["Open Amt"]: datum.openAmount,
        ...(this.showDisputeColumn ? { ["Dispute"]: datum.disputeD365 } : {}),
        ["NC"]: datum.nc,
        ["Branding Consultant"]: datum.brandingConsultant,
        ["BCID"]: datum.bcId,
        ["Note"]: datum.note,
        ["Email Invoice Address"]: datum.invoiceEmailAddress,
        ["Description"]: datum.description,
        ["Inv Date"]: this.datepipe.transform(datum.invDate, "MM-dd-YYYY"),
        ["Due Date"]: this.datepipe.transform(datum.dueDate, "MM-dd-YYYY"),
        ["Payment Reference"]: datum.paymentReference,
        ["Client PO number"]: datum.customerPONumber,
        ["Buyer"]: datum.buyer,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "CustomerAgingDetailReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  clientSettlementcloseModal() {
    this.settlementDisplayModal = false;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  clearFilter(event: CustomerAgingDetailReport[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterCustomerAgingDetailReportLists = event;
    }
  }

  applyFilter(event: CustomerAgingDetailReport[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterCustomerAgingDetailReportLists = event;
    }
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length > 0) {
      this.filterDataCustomerAgingDetailReportLists = event.filteredValue;
    } else {
      this.filterDataCustomerAgingDetailReportLists =
        this.filterCustomerAgingDetailReportLists;
    }
  }
}
